import React from 'react'
import styled from 'styled-components'
import {motion} from 'framer-motion'
import ProfilePic3 from '../Images/ProfilePic3.png'


const Box = styled(motion.div)`

position: absolute;
left: 50%;
top: 50%;
transform: translate(-50%, -50%);


width: 65vw;
height:55vh;
display: flex;


background: linear-gradient(
    to right,
    hsl(263, 29%, 32%) 50%,
    black 50%) bottom,

    linear-gradient(
    to right,
    hsl(263, 29%, 32%) 50%,
    black 50%) top;

    background-repeat: no-repeat;

    background-size: 100% 2px;
    border-left: 2px solid hsl(263, 29%, 32%);
    border-right: 2px solid black;


    z-index:1;

`
const SubBox = styled.div`
width: 50%;
position: relative;
display: flex;

`

const Text = styled.div`
font-size: calc(1em + 1.5vw);
color: ${props => props.theme.body};
padding: 2rem;
cursor: pointer;
}
`

const Intro = () => {
    return (
        <Box
        initial={{height:0}}
        animate={{height: '55vh'}}
        transition={{ type: 'spring', duration:2, delay:1 }}
        >
            <SubBox>
                <Text style={{color:"hsl(263, 29%, 32%)"}}>
                    <h1 className='clickHere'>I'm a Full-Stack developer located who enjoy's to create thoughtful yet beautiful websites with great user experience.</h1>
                    <h1 className='clickHere'>I'm interested in the whole Development Journey Like trying new things and building great projects. I love to write blogs and read books.</h1>
                    <h1 className='clickHere'> I believe everything is an Art when you put your consciousness in it.</h1>
                </Text>
            </SubBox>
            <SubBox>
                <motion.div
                initial={{opacity:0}}
                animate={{opacity: 1}}
                transition={{ duration:1, delay:2 }}
                >
                    <img className="pic" src={ ProfilePic3 } alt="Profile Pic" />
                </motion.div>
            </SubBox>
        </Box>
    )
}

export default Intro

//rgb(250, 200, 100,0.67)